import { combineReducers } from 'redux';
import delayedObjects from 'automation-ui-canvas/reducers/automation/delayedObjects';
import flows from 'automation-ui-canvas/reducers/automation/flows';
import requestStates from 'automation-ui-canvas/reducers/automation/requestStates';
import actionPanel from 'automation-ui-canvas/reducers/automation/actionPanel';
import menuBar from 'automation-ui-canvas/reducers/automation/menuBar';
const rootAutomationReducer = combineReducers({
  delayedObjects,
  flows,
  requestStates,
  actionPanel,
  menuBar
});
export default rootAutomationReducer;